var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.96666C14.95 5.95833 14.8917 5.95833 14.8417 5.96666C13.6917 5.92499 12.775 4.98332 12.775 3.81666C12.775 2.62499 13.7334 1.66666 14.925 1.66666C16.1167 1.66666 17.075 2.63332 17.075 3.81666C17.0667 4.98332 16.15 5.92499 15 5.96666Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1416 12.0333C15.2833 12.225 16.5416 12.025 17.425 11.4333C18.6 10.65 18.6 9.36667 17.425 8.58334C16.5333 7.99167 15.2583 7.79166 14.1166 7.99166",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97496 5.96666C5.02496 5.95833 5.0833 5.95833 5.1333 5.96666C6.2833 5.92499 7.19996 4.98332 7.19996 3.81666C7.19996 2.62499 6.24163 1.66666 5.04996 1.66666C3.8583 1.66666 2.89996 2.63332 2.89996 3.81666C2.9083 4.98332 3.82496 5.92499 4.97496 5.96666Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 12.0333C4.69168 12.225 3.43335 12.025 2.55001 11.4333C1.37501 10.65 1.37501 9.36667 2.55001 8.58334C3.44168 7.99167 4.71668 7.79166 5.85834 7.99166",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 12.1917C9.94996 12.1833 9.89163 12.1833 9.84163 12.1917C8.69163 12.15 7.77496 11.2083 7.77496 10.0417C7.77496 8.85 8.7333 7.89166 9.92496 7.89166C11.1166 7.89166 12.075 8.85833 12.075 10.0417C12.0666 11.2083 11.15 12.1583 9.99996 12.1917Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57498 14.8166C6.39998 15.6 6.39998 16.8833 7.57498 17.6666C8.90831 18.5583 11.0916 18.5583 12.425 17.6666C13.6 16.8833 13.6 15.6 12.425 14.8166C11.1 13.9333 8.90831 13.9333 7.57498 14.8166Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c7cf59acc804768da09d8c2b6e24aa43.svg";
export { ForwardRef as ReactComponent };